module.exports = __webpack_public_path__ + "static/images/styles/images/reserves/rewards/tactical-training-reward-100.095e7f39.png";


//////////////////
// WEBPACK FOOTER
// ./styles/images/reserves/rewards/tactical-training-reward-100.png
// module id = 3800
// module chunks = 11